module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Login",
      "container": false
    }
  }, [_c('div', {
    staticClass: "columns is-desktop "
  }, [_c('div', {
    staticClass: "column is-one-third is-offset-one-third"
  }, [_c('section', {
    staticClass: "mt-4"
  }, [_c('h1', {
    staticClass: "title is-2"
  }, [_vm._v("Request a Demo")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.requestDemo()
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Name),
      expression: "Name"
    }],
    staticClass: "input",
    class: _vm.error && 'is-danger',
    attrs: {
      "type": "text",
      "placeholder": "Your Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Educator Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    class: _vm.error && 'is-danger',
    attrs: {
      "type": "email",
      "placeholder": "Your Educator Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("School or Program")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.group),
      expression: "group"
    }],
    staticClass: "input",
    class: _vm.error && 'is-danger',
    attrs: {
      "type": "text",
      "placeholder": "Your School or Program",
      "required": ""
    },
    domProps: {
      "value": (_vm.group)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.group = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Phone")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input",
    class: _vm.error && 'is-danger',
    attrs: {
      "type": "text",
      "placeholder": "Phone Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control flex-space-between flex-align-center"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Request Demo")])])]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "login-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-67de84c0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestDemo.vue
// module id = 1054
// module chunks = 0